import script from "./OrderMeg.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderMeg.vue?vue&type=script&setup=true&lang=js"

import "./OrderMeg.vue?vue&type=style&index=0&id=54d5ca34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d5ca34"]])

export default __exports__